// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Wrapper---Cx4nP","SliderPreviewsWrapper":"SliderPreviewsWrapper---2ZVHt","Label":"Label---1rhq4","Content":"Content---1_gZJ","TakeoverContent":"TakeoverContent---KYaCm","TakeoverPreview":"TakeoverPreview---3veYw","WelcomeMessagePreview":"WelcomeMessagePreview---3vhqp","SliderPreview":"SliderPreview---FfiFN","PreviewEnter":"PreviewEnter---CkmCr","PreviewLeave":"PreviewLeave---zjn4z"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/MessagePreviews/SliderMessage/SliderMessageBuilder/style.styl
// module id = dfnn
// module chunks = 89